export enum QueryParentType {
    Donor = 1,
    Project = 2,
}
